const Cobalt = Cobalt || {};

Cobalt.utils = {};

Cobalt.utils.createCookie = (() => {
  const init = (name, value, days) => {

    let date = '';
    let expires = '';

    if (days) {
      date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toGMTString()}`;
    } else {
      expires = '';
    }
    const parts = location.hostname.split('.');
    const upperLevelDomain = parts.slice(-2).join('.');
    document.cookie = `${name}=${value}${expires}; path=/; domain=${upperLevelDomain}`;
  };

  return init;
})();

Cobalt.utils.getCookie = (() => {
  const init = (name) => {
    const nameString = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(nameString) === 0) {
        return c.substring(nameString.length, c.length);
      }
    }
    return '';
  };
  return init;
})();